import { useOfferSelectOptions } from "components/UI/Selects/OfferSelectSearchable/useOfferSelectOptions.ts";
import { SearchableSelect, SearchableSelectWrapperProps } from "components/UI/Selects/SearchableSelect/SearchableSelect.tsx";

import FilterRequest = App.Http.Requests.FilterRequest;

type OfferSelectSearchableProps = SearchableSelectWrapperProps & {
    filter?: FilterRequest;
};

export const OfferSelectSearchable = ({ filter, ...props }: OfferSelectSearchableProps) => {
    const hookResult = useOfferSelectOptions({ filter });

    return (
        <SearchableSelect
            hookResult={hookResult}
            translationNamespace="forms.general-fields.offer"
            {...props}
            size={props.size ?? "middle"}
        />
    );
};
